import { render, staticRenderFns } from "./MapEditor.vue?vue&type=template&id=084e1cd5&"
import script from "./MapEditor.vue?vue&type=script&lang=js&"
export * from "./MapEditor.vue?vue&type=script&lang=js&"
import style0 from "./MapEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports